<div class="ambassadors-box">
  <span class="icon-close" (click)="closeAmbassadors()"></span>
  <div class="ctent-ambassadors">
    <p class="tit-time"><span>{{ month | titlecase }}</span></p>
    <table>
      <tbody>
        <tr>
          <th>{{ 'Nickname' | translate | uppercase }}</th>
          <th>{{ 'City' | translate | uppercase }}</th>
          <th>{{ 'Areas' | translate | uppercase }}</th>
        </tr>
        <tr *ngFor="let user of contributors">
          <td>{{ user.username }}</td>
          <td>{{ user.city }}</td>
          <td>{{ user.surveys }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="bg-popup"></div>